export default {
  fa: {
    title: 'عنوان', description: 'توضیحات', language: 'زبان', linkType: 'نوع پیوند', internal: 'داخلی', external: 'خارجی', url: 'آدرس پیوند', save: 'ذخیره', back: 'بازگشت', failed: 'ذخیره یا دریافت اطلاعات انجام نشد. دوباره تلاش کنید.', invalid: 'برای پیوند داخلی آدرس نسبی و برای پیوند خارجی آدرس HTTP یا HTTPS وارد کنید.',
  },
  en: {
    title: 'Title', description: 'Description', language: 'Language', linkType: 'Link type', internal: 'Internal', external: 'External', url: 'Link URL', save: 'Save', back: 'Back', failed: 'Could not save or load this menu. Please try again.', invalid: 'Use a relative URL for internal links and HTTP or HTTPS for external links.',
  },
  ar: {
    title: 'العنوان', description: 'الوصف', language: 'اللغة', linkType: 'نوع الرابط', internal: 'داخلي', external: 'خارجي', url: 'عنوان الرابط', save: 'حفظ', back: 'رجوع', failed: 'تعذر حفظ القائمة أو تحميلها. يرجى المحاولة مجدداً.', invalid: 'استخدم عنواناً نسبياً للرابط الداخلي وHTTP أو HTTPS للرابط الخارجي.',
  },
}
